/* import __COLOCATED_TEMPLATE__ from './attribute-picker-opener.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { computed } from '@ember/object';
import { or, not, and } from '@ember/object/computed';
import Component from '@ember/component';
import { ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import { inject as service } from '@ember/service';
export default Component.extend({
  intl: service(),
  attributeItemComponent: null,
  isDisabled: or('isInvalid', 'isForceDisabled'),
  isValid: true,
  isInvalid: not('isValid'),
  isForceDisabled: false,
  label: computed('intl.locale', function () {
    return this.intl.t('components.modal.opt-in-to-subscription-type.user-list.attribute-picker-opener.add-filter');
  }),
  attributeBindings: ['data-test-attribute-picker-opener', 'data-test-add-user-predicate-button'],
  'data-test-attribute-picker-opener': true,
  shouldShowFilter: computed('shouldShowAttributeFilter', function () {
    if (this.shouldShowAttributeFilter === undefined) {
      return true;
    }
    return this.shouldShowAttributeFilter;
  }),
  shouldShowTooltip: or('isInvalid', 'isForceDisabledAndHasTooltipContent'),
  // does not show tooltip if you explicitly override isDisabled
  isForceDisabledAndHasTooltipContent: and('isForceDisabled', 'disabledTooltipContent'),
  tooltipContent: ternaryToProperty('isInvalid', 'invalidTooltipContent', 'disabledTooltipContent'),
  invalidTooltipContent: '',
  disabledTooltipContent: '',
  init() {
    this._super(...arguments);
    this.set('invalidTooltipContent', this.intl.t('components.modal.opt-in-to-subscription-type.user-list.attribute-picker-opener.invalid-tooltip-content'));
  }
});